export class BaseLogModel {

    public IDBaseLog: string;
    public IDBase: string;
    public Type: number;
    public Content: string;

    constructor(IDBase: string, Type: number, Content: string) {
        this.IDBase = IDBase;
        this.Type = Type;
        this.Content = Content;
    }
}
